export default {
    job: 'งาน',
    searcJob: 'ค้นหางาน',
    search: 'ค้นหา',
    jobName: 'ชื่องาน',
    jobAddress: 'ที่อยู่งาน',
    contactPerson: 'ผู้ติดต่อ',
    action: 'แก้ไข',
    createJob: 'สร้างงาน',
    congratulation: 'ยินดีด้วย',
    errorMessage: 'เกิดข้อผิดพลาด',
    deleteJob: 'ลบงาน',
    wantToDelete: 'คุณเเน่ใจว่าต้องการที่จะลบงาน',
    jobIsDeleted: 'งานถูกลบแล้ว'
}
